import React, { useState } from 'react';
import { Container, Divider, Link, Typography } from '@material-ui/core';
import Mail from '@material-ui/icons/Mail';
import Smartphone from '@material-ui/icons/Smartphone';
import { LoadingBounce } from '@michelin/acid-components';
import { useTranslation } from '@michelin/central-provider';
import { useGetApprovalContacts } from 'hooks/useGetApprovalContacts';
import { formatProfileName } from 'utils/format';
import { v4 as uuidv4 } from 'uuid';

interface AdminContactsProps {
  fleetId?: string;
}

export function AdminContacts({ fleetId }: AdminContactsProps) {
  const { t } = useTranslation();
  const [expand, setExpand] = useState(false);

  const contactsResponse = useGetApprovalContacts({
    // eslint-disable-next-line @typescript-eslint/naming-convention
    fleet_id: fleetId || '',
    amount: 0,
  });

  const contacts = Array.isArray(contactsResponse?.data) ? contactsResponse?.data : [];
  if (contactsResponse.isLoading) return <LoadingBounce />;
  if (!contacts || contacts.length === 0) {
    return (
      <Typography>
        {t('There are no users configured to approve orders on this fleet. Please contact your administrator.')}
      </Typography>
    );
  }

  return (
    <>
      {contacts.length > 0 &&
        contacts.map((c, index) => (
          <Container key={uuidv4()}>
            {(index < 3 || expand) && (
              <>
                <Typography color="primary">{formatProfileName(c)}</Typography>
                {c.email_address && (
                  <Typography style={{ fontSize: 10, marginTop: 8 }}>
                    <Mail style={{ height: 16, verticalAlign: 'bottom', marginRight: 8 }} />
                    {c.email_address}
                  </Typography>
                )}
                {c.cell_phone && (
                  <Typography style={{ fontSize: 10, marginTop: 8 }}>
                    <Smartphone style={{ height: 16, verticalAlign: 'bottom', marginRight: 8 }} />
                    {c.cell_phone}
                  </Typography>
                )}
                {index < contacts.length - 1 && (expand || index < 2) && (
                  <Divider style={{ marginTop: 16, marginBottom: 8 }} />
                )}
              </>
            )}
          </Container>
        ))}
      <div style={{ marginTop: 16, cursor: 'pointer' }}>
        {contacts.length > 3 && !expand && <Link onClick={() => setExpand(true)}>{t('Display all...')}</Link>}
        {contacts.length > 3 && expand && <Link onClick={() => setExpand(false)}>{t('Collapse...')}</Link>}
      </div>
    </>
  );
}
